import { useEffect, useState } from "react";

import useFeatureFlags, { getFieldGroupFlag } from "hooks/useFeatureFlags";

import { IGroupByListItem } from "models";

import { useGroupByStore } from "../GroupByStoreProvider";
import { selectCategoryList, selectProps } from "../groupBySelectors";
import filterByCategory from "../helpers/filterByCategory";

export const geoVolumeCategoryTitle = "Sampled 3D Geo";
export const padMetricsCategoryTitle = "Pad Metrics";
/**
 * Returns a filtered list of categories after applying:
 * - exclude-category filter
 * - field-group feature-flag filter (EVA-10): a category (e.g. "Header",
 *   "Forecast") whose "<Category> Fields" flag is disabled is hidden from
 *   this list — the same categories the data-table column chooser filters —
 *   so groupBy/filter field pickers built on `GroupByWrapper` stay in sync.
 */
const useCategories = (): IGroupByListItem[] => {
  const [list, setList] = useState<Maybe<IGroupByListItem[]>>(null);

  const categoryList = useGroupByStore(selectCategoryList);
  const props = useGroupByStore(selectProps);
  const { hasFeature } = useFeatureFlags();

  useEffect(() => {
    if (!categoryList?.length) {
      setList([]);
      return;
    }

    const newCategoryList = [...categoryList];

    const filteredCategories = filterByCategory(
      props.excludedCategoryFilters,
      newCategoryList
    ).filter((category) => {
      const flag = getFieldGroupFlag(category.name);
      return !flag || hasFeature(flag);
    });

    setList(filteredCategories);
  }, [props?.excludedCategoryFilters, categoryList, hasFeature]);

  return list;
};

export default useCategories;
